/* ===== Coochipoo theme JS ===== */
(function () {
  var money = window.CCP_MONEY_FORMAT || '₹{{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100);
    var noDecimals = /no_decimals/.test(money);
    var str = value.toLocaleString('en-IN', {
      minimumFractionDigits: noDecimals ? 0 : 2,
      maximumFractionDigits: noDecimals ? 0 : 2
    });
    // Match any Shopify money placeholder that contains "amount"
    return money.replace(/\{\{\s*\w*amount\w*\s*\}\}/, str);
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ccp-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200);
  }
  window.ccpToast = toast;

  /* ---------- Cart drawer ---------- */
  function openDrawer() {
    var d = document.getElementById('ccp-cart-drawer');
    var o = document.getElementById('ccp-cart-overlay');
    if (d) d.classList.add('is-open');
    if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = document.getElementById('ccp-cart-drawer');
    var o = document.getElementById('ccp-cart-overlay');
    if (d) d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.ccpOpenCart = openDrawer;
  window.ccpCloseCart = closeDrawer;

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshDrawer() {
    return fetch('/?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#ccp-drawer-contents');
        var current = document.getElementById('ccp-drawer-contents');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }

  /* ---------- AJAX add to cart ---------- */
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: data })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body && res.body.description ? res.body.description : 'Could not add to cart'); return; }
        toast((res.body.product_title || 'Added') + ' added 🐾');
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartCount(cart.item_count);
          return refreshDrawer().then(openDrawer);
        });
      })
      .catch(function () { toast('Could not add to cart'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
  }

  /* ---------- Cart line item change (drawer + cart page) ---------- */
  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      return cart;
    });
  }
  window.ccpChangeLine = changeLine;

  /* ---------- Rails ---------- */
  function scrollRail(id, dir) {
    var el = document.getElementById(id);
    if (!el) return;
    var max = el.scrollWidth - el.clientWidth;
    var next = el.scrollLeft + dir * Math.round(el.clientWidth * 0.78);
    el.scrollTo({ left: Math.max(0, Math.min(max, next)), behavior: 'smooth' });
  }
  window.ccpScrollRail = scrollRail;

  /* ---------- Hero slider ---------- */
  function initSliders() {
    document.querySelectorAll('[data-ccp-slider]').forEach(function (slider) {
      if (slider._ccpInit) return;
      slider._ccpInit = true;
      var slides = slider.querySelectorAll('[data-slide]');
      var dots = slider.querySelectorAll('[data-dot]');
      if (slides.length < 2) return;
      var i = 0, timer;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          s.style.opacity = idx === i ? '1' : '0';
          s.style.pointerEvents = idx === i ? 'auto' : 'none';
        });
        dots.forEach(function (d, idx) {
          d.style.width = idx === i ? '32px' : '12px';
          d.style.background = idx === i ? 'var(--color-dark)' : '#fff';
        });
      }
      function start() { timer = setInterval(function () { show(i + 1); }, 4500); }
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { clearInterval(timer); show(idx); start(); }); });
      show(0); start();
    });
  }

  /* ---------- Product page (variant + gallery) ---------- */
  function initProduct() {
    var root = document.querySelector('[data-ccp-product]');
    if (!root || root._ccpInit) return;
    root._ccpInit = true;

    // Gallery thumbnails
    var main = root.querySelector('[data-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) { main.src = btn.getAttribute('data-full'); }
        root.querySelectorAll('[data-thumb]').forEach(function (b) { b.style.borderColor = 'rgba(32,32,29,.10)'; });
        btn.style.borderColor = 'var(--color-pink)';
      });
    });

    // Variant option buttons (the JSON script may sit just outside the section,
    // so fall back to a document-wide lookup)
    var variantsData = root.querySelector('[data-variants-json]') || document.querySelector('[data-variants-json]');
    var variants = variantsData ? JSON.parse(variantsData.textContent) : [];
    var selected = {};
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');

    function currentVariant() {
      var keys = Object.keys(selected);
      return variants.find(function (v) {
        return keys.every(function (k) {
          return String(v.options[k]) === String(selected[k]);
        });
      });
    }
    function syncVariant() {
      var v = currentVariant();
      var btn = root.querySelector('[data-add-btn]');
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price_str || formatMoney(v.price);
        if (btn) {
          btn.disabled = !v.available;
          btn.innerHTML = v.available ? 'Add to cart 🐾' : 'Sold out';
        }
      }
    }
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      group.querySelectorAll('[data-value]').forEach(function (b) {
        b.addEventListener('click', function () {
          selected[idx] = b.getAttribute('data-value');
          group.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('data-selected', 'false'); });
          b.setAttribute('data-selected', 'true');
          syncVariant();
        });
      });
      // preselect first
      var first = group.querySelector('[data-value]');
      if (first) { selected[idx] = first.getAttribute('data-value'); first.setAttribute('data-selected', 'true'); }
    });
    syncVariant();

    // Quantity stepper
    var qtyInput = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-qty-step'), 10);
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = val;
      });
    });
  }

  /* ---------- Wire it all up ---------- */
  var _delegated = false;
  function boot() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      if (form._ccpBound || form.hasAttribute('data-no-ajax')) return;
      form._ccpBound = true;
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form); });
    });
    document.querySelectorAll('[data-open-cart]').forEach(function (el) {
      if (el._ccpBound) return; el._ccpBound = true;
      el.addEventListener('click', function (e) { e.preventDefault(); refreshDrawer().then(openDrawer); });
    });
    document.querySelectorAll('[data-close-cart]').forEach(function (el) {
      if (el._ccpBound) return; el._ccpBound = true;
      el.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
    });
    if (!_delegated) {
      _delegated = true;
      document.addEventListener('click', function (e) {
        var qa = e.target.closest('[data-quick-add]');
        if (qa) {
          e.preventDefault();
          var vid = qa.getAttribute('data-quick-add');
          var body = new FormData();
          body.append('id', vid); body.append('quantity', 1);
          fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: body })
            .then(function (r) { return r.json(); })
            .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
            .then(function (cart) { updateCartCount(cart.item_count); toast('Added 🐾'); return refreshDrawer().then(openDrawer); })
            .catch(function () { toast('Could not add to cart'); });
        }
        var rm = e.target.closest('[data-line-remove]');
        if (rm) {
          e.preventDefault();
          changeLine(parseInt(rm.getAttribute('data-line-remove'), 10), 0).then(function () { refreshDrawer(); });
        }
      });
    }
    initSliders();
    initProduct();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
